// src/components/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <div className="bg-gray-300 text-grey py-10 px-4">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Логотип */}
        <div className="flex justify-center md:justify-start items-center">
          <a href="/contact">
            <img
              src="https://www.yos-studio.com/wp-content/uploads/2022/12/logo-yos-svg-studio-graficzne-poznan.svg"
              alt="yos studio logo"
              className="w-16 h-16 rotate"
            />
          </a>
          <p className="ml-4 text-lg font-light">Skontaktuj się z nami:</p>
        </div>

        {/* Контактная информация */}
        <div className="text-center ">
          {/* <p className="text-lg font-light">Skontaktuj się z nami:</p> */}
          <a href="mailto:biuro@yos-studio.com" className="block text-lg font-light mt-2">
            biuro@yos-studio.com
          </a>
          <a href="tel:+48517076086" className="block text-lg font-light mt-2">
          +48 517 076 086
          </a>
        </div>

        {/* Адрес */}
        <div className="text-center md:text-right">
          <p className="text-lg font-light mt-2">Głogowska 77/7</p>
          <p className="text-lg font-light mt-2">Poznań 60-739</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;